import { getRowsToDisplay } from "../helpers";

export const onFilterChangedEvent = ({ gridRef, onFilterChanged, params, setRowsToDisplay }) => {
  let rowsToDisplay = getRowsToDisplay(params);
  if (onFilterChanged) onFilterChanged(params);

  setRowsToDisplay(rowsToDisplay.length);
  gridRef.current.api.refreshCells({ force: true });
}